import React from 'react'
import { Link } from "react-router-dom";

import ubicacion from '../assets/images/icons/ubicacion.png'
import bus from '../assets/images/icons/bus.png'
import desembarque from '../assets/images/icons/desembarque.png'

import '../css/puertoAutoridades.scss'



export default function PuertosAutoridades() {
  return (
    <>
        <section className='puertos'>
            <div className='container'>

                <div className='puertos-title'>
                    <h2>Puertos y autoridades</h2>
                </div>
                

                <div className='puertos-content'>

                    {/* ITEM */}
                    <div className='puertos-item'>
                        <Link to="/como-llegar">   

                        <div className='puertos-icon'>
                            <img src={ubicacion} alt='Cómo llegar al puerto' />
                        </div>
                        </Link> 

                        <div className='puertos-info'>
                            <h3>Cómo llegar al puerto</h3>

                            <p>
                                Consulta rutas, accesos y estacionamientos
                                para llegar a tiempo.
                            </p>
                            <Link to="/como-llegar">
                                Ver más
                                <i className="fi fi-rr-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                    {/* ITEM */}
                    <div className='puertos-item'>
                        <Link to="/proceso-de-dembarque"> 
                        <div className='puertos-icon'>
                            <img src={bus} alt='Proceso de embarque' />
                        </div>
                        </Link>

                        <div className='puertos-info'>
                            <h3>Proceso de embarque</h3>

                            <p>
                                Aprende paso a paso el proceso:
                                registro, controles y abordaje.
                            </p>
                            <Link to="/proceso-de-dembarque">
                                Ver más
                                <i className="fi fi-rr-arrow-right"></i>
                            </Link> 
                        </div>
                    </div>

                    {/* ITEM */}
                    <div className='puertos-item'>
                        <Link to="/desembarque-pasajero">
                        <div className='puertos-icon'>
                            <img src={desembarque} alt='Salida en destino' />
                        </div>
                        </Link>

                        <div className='puertos-info'>
                            <h3>Desembarque</h3>

                            <p>
                                Descubre cómo es el proceso de desembarque para pasajeros.
                            </p>
                            <Link to="/desembarque-pasajero">
                                Ver más
                                <i className="fi fi-rr-arrow-right"></i>
                            </Link>
                        </div>
                    </div>

                </div>


                <div className='puertos-cards'>

                    {/* CARD */}
                    <div className='puertos-card'>

                        <a href="https://www.puertosyucatan.com/sp/files/2023/Guía_de_Usuario_PIS_.pdf" target="_blank" rel="noopener noreferrer" className='puertos-card-info'>

                            <h3>Guía de usuario PIS</h3>
                            <p> Guía para solicitar el usuario y contraseña para ingresar a la plataforma Puerto Inteligente Seguro (PIS).</p>                            
                                                        
                        </a>

                    </div>

                
                    {/* CARD */}
                    <div className='puertos-card'>

                        <Link to='/que-incluye'>
                            <div className='puertos-card-info'>

                                <h3>¿Qué incluye tu boleto?</h3>
                                <p>Conoce todos los servicios y beneficios incluidos en tu boleto: acceso al barco, áreas comunes, equipaje permitido y más.</p>
                            </div>
                        </Link> 

                    </div>

                    {/* CARD */}
                    <div className='puertos-card'>


                         <Link to='/servicios-adicionales'>
                            <div className='puertos-card-info'>

                                <h3>Servicios adicionales</h3> 
                            <p>
                                Infórmate sobre los servicios y comodidades para disfrutar al máximo tu viaje.
                            </p>
                            </div>
                        </Link>       

                    </div>
                </div>


            </div>
        </section>
    </>
  )
}
